<script lang="ts">
  import logo from "@images/logo/mark_white_gradated.svg"

  logo
</script>

<footer class="bg-lwp-accent">
  <div
    class="max-w-7xl mx-auto py-4 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8"
  >
    <div class="flex justify-center space-x-6">
      <a
        href="https://www.facebook.com/LeadWithPurpose"
        target="_blank"
        rel="noopener noreferrer"
        class="text-white hover:text-indigo-300 border rounded-full p-1"
      >
        <span class="sr-only">Facebook</span>
        <svg
          class="h-5 w-5"
          fill="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
            clip-rule="evenodd"
          />
        </svg>
      </a>

      <a
        href="https://www.instagram.com/leadwithpurpose"
        target="_blank"
        rel="noopener noreferrer"
        class="text-white hover:text-indigo-300 border rounded-full p-1"
      >
        <span class="sr-only">Instagram</span>
        <svg
          class="h-5 w-5"
          fill="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
            clip-rule="evenodd"
          />
        </svg>
      </a>

      <a
        href="https://www.youtube.com/user/LeadWithPurpose"
        target="_blank"
        rel="noopener noreferrer"
        class="text-white hover:text-indigo-300 border rounded-full p-1"
      >
        <span class="sr-only">YouTube</span>
        <svg
          class="h-5 w-5"
          fill="currentColor"
          aria-hidden="true"
          data-icon="youtube"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <path
            fill-rule="evenodd"
            d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
          /></svg
        >
      </a>

      <a
        href="https://www.linkedin.com/company/leadwithpurpose/"
        target="_blank"
        rel="noopener noreferrer"
        class="text-white hover:text-indigo-300 border rounded-full p-1"
      >
        <span class="sr-only">LinkedIn</span>
        <svg
          class="h-5 w-5"
          fill="currentColor"
          viewBox="0 0 448 512"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
          />
        </svg>
      </a>
    </div>

    <div class="hidden md:inline-flex">
      <img src={logo} alt="Logo" class="h-12 w-auto" />
    </div>
    <div class="mt-8 md:mt-0">
      <div class="flex py-1 justify-center md:justify-end items-center">
        <p
          class="text-center md:text-right text-base text-white hover:underline hover:text-blue-100"
        >
          <a href="/terms">Terms</a>
        </p>
        <p class="text-center md:text-right text-base text-gray-200 px-2">|</p>
        <p
          class="text-center md:text-right text-base text-white hover:underline hover:text-blue-100"
        >
          <a href="/privacy">Privacy Policy</a>
        </p>
        <p class="text-center md:text-right text-base text-gray-200 px-2">|</p>
        <p
          class="text-center md:text-right text-base text-white hover:underline hover:text-blue-100"
        >
          <a href="/contact">Contact Us</a>
        </p>
      </div>
      <p class="text-center md:text-right text-base text-white">
        &copy; {new Date().getFullYear()} Lead With Purpose. All rights reserved.
      </p>
    </div>
  </div>
</footer>
